function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/* eslint-disable */
import React from 'react';
import TextInput from "../../../../../../../wdh-feature/wdh-feature-b2b-us/src/js/components/text-input";
import TranslationManager from "../../../../../../../wdh-feature/wdh-feature-b2b-us/src/js/infrastructure/translation-manager";
import { TranslationKeys } from "../../../../../../../wdh-feature/wdh-feature-b2b-us/src/js/infrastructure/const";
import PropTypes from "prop-types";
var UserManagementAddNewUserForm = /*#__PURE__*/function (_React$Component) {
  function UserManagementAddNewUserForm(props) {
    var _this;
    _classCallCheck(this, UserManagementAddNewUserForm);
    _this = _callSuper(this, UserManagementAddNewUserForm, [props]);
    _this.translations = {
      FirstNameText: TranslationManager.getTranslation(TranslationKeys.USER_MANAGEMENT_ADD_FIRST_NAME_TEXT),
      MiddleNameText: TranslationManager.getTranslation(TranslationKeys.USER_MANAGEMENT_ADD_MIDDLE_NAME_TEXT),
      LastNameText: TranslationManager.getTranslation(TranslationKeys.USER_MANAGEMENT_ADD_LAST_NAME_TEXT),
      UserIDText: TranslationManager.getTranslation(TranslationKeys.USER_MANAGEMENT_ADD_USER_ID_TEXT),
      PhoneTextAddUser: TranslationManager.getTranslation(TranslationKeys.USER_MANAGEMENT_PHONE_TEXT),
      FaxTextAddUser: TranslationManager.getTranslation(TranslationKeys.USER_MANAGEMENT_FAX_TEXT),
      mandatoryFormField: TranslationManager.getTranslation(TranslationKeys.SHARED_MANDATORYFORMFIELD)
    };
    return _this;
  }
  _inherits(UserManagementAddNewUserForm, _React$Component);
  return _createClass(UserManagementAddNewUserForm, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var user = this.props.user;
      var errors = this.props.errors;
      return /*#__PURE__*/React.createElement("div", {
        className: "react-form"
      }, /*#__PURE__*/React.createElement("span", {
        className: "has-value"
      }, /*#__PURE__*/React.createElement(TextInput, {
        name: "firstname",
        id: "firstName",
        onValueChange: function onValueChange(event) {
          _this2.props.onUserUpdated(event.target.value, user.middleName, user.lastName, user.userId, user.businessEmail, user.phone, user.fax);
        },
        inputValue: user.firstName,
        hasError: errors.field.includes('firstName'),
        showHelpText: errors.field.includes('firstName'),
        helpTextHTML: this.translations.mandatoryFormField,
        autoComplete: "given-name"
      }), /*#__PURE__*/React.createElement("span", {
        className: "placeholder"
      }, this.translations.FirstNameText)), /*#__PURE__*/React.createElement("span", {
        className: "has-value"
      }, /*#__PURE__*/React.createElement(TextInput, {
        name: "middlename",
        id: "middleName",
        onValueChange: function onValueChange(event) {
          _this2.props.onUserUpdated(user.firstName, event.target.value, user.lastName, user.userId, user.businessEmail, user.phone, user.fax);
        },
        inputValue: user.middleName,
        autoComplete: "additional-name"
      }), /*#__PURE__*/React.createElement("span", {
        className: "placeholder"
      }, this.translations.MiddleNameText)), /*#__PURE__*/React.createElement("span", {
        className: "has-value"
      }, /*#__PURE__*/React.createElement(TextInput, {
        name: "lastname",
        id: "lastName",
        onValueChange: function onValueChange(event) {
          _this2.props.onUserUpdated(user.firstName, user.middleName, event.target.value, user.userId, user.businessEmail, user.phone, user.fax);
        },
        inputValue: user.lastName,
        hasError: errors.field.includes('lastName'),
        showHelpText: errors.field.includes('lastName'),
        helpTextHTML: this.translations.mandatoryFormField,
        autoComplete: "family-name"
      }), /*#__PURE__*/React.createElement("span", {
        className: "placeholder"
      }, this.translations.LastNameText)), /*#__PURE__*/React.createElement("span", {
        className: "has-value"
      }, /*#__PURE__*/React.createElement(TextInput, {
        name: "userid",
        id: "userId",
        onValueChange: function onValueChange(event) {
          _this2.props.onUserUpdated(user.firstName, user.middleName, user.lastName, event.target.value, user.businessEmail, user.phone, user.fax);
        },
        inputValue: user.userId,
        hasError: errors.field.includes('userId'),
        showHelpText: errors.field.includes('userId'),
        helpTextHTML: this.translations.mandatoryFormField,
        autoComplete: "username"
      }), /*#__PURE__*/React.createElement("span", {
        className: "placeholder"
      }, this.translations.UserIDText)), /*#__PURE__*/React.createElement("span", {
        className: "has-value"
      }, /*#__PURE__*/React.createElement(TextInput, {
        name: "businessEmail",
        id: "businessEmail",
        onValueChange: function onValueChange(event) {
          _this2.props.onUserUpdated(user.firstName, user.middleName, user.lastName, user.userId, event.target.value, user.phone, user.fax);
        },
        inputValue: user.businessEmail,
        hasError: errors.field.includes('businessEmail'),
        showHelpText: errors.field.includes('businessEmail'),
        helpTextHTML: this.translations.mandatoryFormField,
        autoComplete: "email work"
      }), /*#__PURE__*/React.createElement("span", {
        className: "placeholder"
      }, "Business email:*")), /*#__PURE__*/React.createElement("span", {
        className: "has-value"
      }, /*#__PURE__*/React.createElement(TextInput, {
        name: "phone",
        id: "phone",
        onValueChange: function onValueChange(event) {
          _this2.props.onUserUpdated(user.firstName, user.middleName, user.lastName, user.userId, user.businessEmail, event.target.value, user.fax);
        },
        inputValue: user.phone,
        hasError: errors.field.includes('phone'),
        showHelpText: errors.field.includes('phone'),
        helpTextHTML: this.translations.mandatoryFormField,
        autoComplete: "tel"
      }), /*#__PURE__*/React.createElement("span", {
        className: "placeholder"
      }, this.translations.PhoneTextAddUser)), /*#__PURE__*/React.createElement("span", {
        className: "has-value"
      }, /*#__PURE__*/React.createElement(TextInput, {
        name: "fax",
        id: "fax",
        onValueChange: function onValueChange(event) {
          _this2.props.onUserUpdated(user.firstName, user.middleName, user.lastName, user.userId, user.businessEmail, user.phone, event.target.value);
        },
        inputValue: user.fax,
        autoComplete: "fax"
      }), /*#__PURE__*/React.createElement("span", {
        className: "placeholder"
      }, this.translations.FaxTextAddUser)));
    }
  }]);
}(React.Component);
UserManagementAddNewUserForm.propTypes = {
  user: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool])),
  onUserUpdated: PropTypes.func.isRequired,
  errors: PropTypes.arrayOf(PropTypes.shape({
    valid: PropTypes.bool,
    field: PropTypes.arrayOf(PropTypes.string)
  }))
};
UserManagementAddNewUserForm.defaultProps = {
  user: {},
  errors: {
    valid: true,
    field: []
  }
};
export default UserManagementAddNewUserForm;